import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './index.module.scss';
import Button from 'components/Button';

import FormPopup from 'components/Operational/FormPopup';
import InputLabel from '@material-ui/core/InputLabel';
import { t } from 'i18next';

const MakeEventInappropriate = ({
  popupTitle,
  PopupForm,
  popupFormSubmitHandler,
}) => {
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const onClickSetInappropriate = () => {
    setShowConfirmPopup(true);
  };
  const closePopupHandler = () => {
    setShowConfirmPopup(false);
  };
  const onClickSubmit = formValues => {
    popupFormSubmitHandler(formValues);
    closePopupHandler();
  };

  return (
    <>
      <div className={cn(styles.operationalView, styles.btnWithLabel)}>
        <InputLabel>{t('Inappropriate Event')}:</InputLabel>
        <Button
          text="Lodge Report"
          className={styles.button}
          color={'secondary'}
          onClick={onClickSetInappropriate}
        />
      </div>
      {showConfirmPopup && (
        <FormPopup
          headerTitle={popupTitle}
          closePopup={closePopupHandler}
          form={<PopupForm submit={onClickSubmit} />}
        />
      )}
    </>
  );
};

MakeEventInappropriate.propTypes = {
  popupTitle: PropTypes.string,
  PopupForm: PropTypes.func,
  popupFormSubmitHandler: PropTypes.func,
};

export default MakeEventInappropriate;
